export default {
  title: 'Select the occasion',
};
